var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTimesheetErrorNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6945 5.65468L10.4218 2.3165C10.2133 2.10959 9.9301 1.99553 9.63636 2.00013H3.09091C2.48842 2.00013 2 2.48855 2 3.09104V12.9092C2 13.5117 2.48842 14.0001 3.09091 14.0001H12.9091C13.5116 14.0001 14 13.5117 14 12.9092V6.36377C13.988 6.09807 13.8794 5.8459 13.6945 5.65468ZM9.63636 3.09104L12.9091 6.36377H9.63636V3.09104ZM3.09091 12.9092V3.09104H8.54545V6.36377C8.54545 6.96626 9.03387 7.45468 9.63636 7.45468H12.9091V12.9092H3.09091Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 8V4.8",
    stroke: "#161616",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.20039,
    cy: 10.4016,
    r: 0.8,
    fill: "#161616"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTimesheetErrorNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timesheet_error_note.009ba213272ece53b7f0315e071134da.svg";